import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePublisherAuth } from '../contexts/PublisherAuthContext';

const PublisherProtectedRoute = ({ children }) => {
  const { isPublisherAuthenticated, isPublisherLoading } = usePublisherAuth();
  const location = useLocation();

  if (isPublisherLoading) {
    return <div style={{ padding: '50px', textAlign: 'center' }}>Loading Publisher Session...</div>;
  }

  if (!isPublisherAuthenticated) {
    // Redirect them to the publisher login page
    return <Navigate to="/publisher/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PublisherProtectedRoute;